// API_COMPATIBILITY_VERSION is a monotonically increasing
// value that is used to express breaking API changes to the
// front-end. When an engineer makes a change to the API that
// is not compatible with the currently deployed version of
// the client, they can bump this version. Doing so will
// immediately display the update prompt to any users that
// that hitting the API with an old client.
//
// The way this will work is that this version number will be
// returned as a header from every API request. The client
// will use an HttpIntercepter to check this header against
// the version number that it knows. If these ever disagree,
// we'll know that an engineer has intentionally bumped this
// number and is anticipating breakage.
export const API_COMPATIBILITY_VERSION = 19;

// LAST_EDITOR is intended to act as a citation to help avoid
// merge conflicts. Add your name here if you make any version
// bumps. If two engineers both branch off of main at version
// 1 and attempt to bump to 2, this line will conflict,
// facilitating coordination between those two distinct version
// bumps. The second PR will then most likely resolve the conflict
// and bump to 3 to ensure their version bump takes effect.
const LAST_EDITOR = 'Josh';
